import formatDecimal from './format-decimal';

var exponent = function exponent(a) {
  return a = formatDecimal(Math.abs(a)), a ? a[1] : NaN;
};

export default exponent;